import minBy from "lodash/minBy";
import maxBy from "lodash/maxBy";
import mapValues from "lodash/mapValues";
import isNumber from "lodash/isNumber";
import toNumber from "lodash/toNumber";
import supportedUnits from "../../../../../../graylog2-server/src/main/resources/units/supported_units.json";
const sourceUnits = supportedUnits.units;
const isUnitUsableInPrettier = (unitJson) => !(unitJson.unit_type === "percent" && unitJson.abbrev === "d%");
const unitFromJson = (unitJson) => ({
  type: unitJson.type,
  abbrev: unitJson.abbrev,
  name: unitJson.name,
  unitType: unitJson.unit_type,
  conversion: unitJson.conversion,
  useInPrettier: isUnitUsableInPrettier(unitJson)
});
export const mappedUnitsFromJSON = mapValues(
  sourceUnits,
  (unitsJson) => unitsJson.map((unitJson) => unitFromJson(unitJson))
);
export const _getBaseUnit = (units, unitType) => units[unitType].find(({ type }) => type === "base");
const _convertValueToBaseUnit = (units, value, params) => {
  var _a, _b;
  if (!(isNumber(value) && (params == null ? void 0 : params.unitType) && (params == null ? void 0 : params.abbrev))) return { value: null, unit: null };
  const unit = units[params.unitType].find(({ abbrev }) => params.abbrev === abbrev);
  const baseUnit = _getBaseUnit(units, params.unitType);
  const res = {
    value: null,
    unit: baseUnit
  };
  if (baseUnit.abbrev === params.abbrev) {
    res.value = value;
    return res;
  }
  if (((_a = unit == null ? void 0 : unit.conversion) == null ? void 0 : _a.action) === "MULTIPLY") {
    res.value = value * unit.conversion.value;
  }
  if (((_b = unit == null ? void 0 : unit.conversion) == null ? void 0 : _b.action) === "DIVIDE") {
    res.value = value / unit.conversion.value;
  }
  return res;
};
const _convertValueToUnit = (units, value, fromParams, toParams) => {
  var _a, _b;
  if (!(isNumber(value) && (fromParams == null ? void 0 : fromParams.unitType) && (fromParams == null ? void 0 : fromParams.abbrev) && (toParams == null ? void 0 : toParams.abbrev) && (toParams == null ? void 0 : toParams.unitType)))
    return { value: null, unit: null };
  if (fromParams.unitType === toParams.unitType && fromParams.abbrev === toParams.abbrev) {
    const unit2 = units[toParams.unitType].find(({ abbrev }) => toParams.abbrev === abbrev);
    return { value, unit: unit2 };
  }
  const baseValue = _convertValueToBaseUnit(units, value, fromParams);
  const unit = units[toParams.unitType].find(({ abbrev }) => toParams.abbrev === abbrev);
  const res = { value: null, unit };
  if (baseValue.unit.abbrev === toParams.abbrev) {
    res.value = baseValue.value;
    return res;
  }
  if (((_a = unit == null ? void 0 : unit.conversion) == null ? void 0 : _a.action) === "MULTIPLY") {
    res.value = baseValue.value / unit.conversion.value;
  }
  if (((_b = unit == null ? void 0 : unit.conversion) == null ? void 0 : _b.action) === "DIVIDE") {
    res.value = baseValue.value * unit.conversion.value;
  }
  return res;
};
export const _getPrettifiedValue = (units, initValue, params) => {
  var _a;
  const currentUnit = (_a = units == null ? void 0 : units[params == null ? void 0 : params.unitType]) != null ? _a : null;
  const _value = initValue === null ? null : toNumber(initValue);
  if (!(_value && currentUnit))
    return { value: _value, unit: currentUnit ? currentUnit.find(({ abbrev }) => abbrev === params.abbrev) : null };
  const sign = Math.sign(_value);
  const absolutValue = Math.abs(_value);
  const allConvertedValues = Object.values(currentUnit).map(
    (unit) => _convertValueToUnit(units, absolutValue, params, { abbrev: unit.abbrev, unitType: unit.unitType })
  );
  const filtratedValues = allConvertedValues.filter(({ value: val, unit }) => val >= 1 && unit.useInPrettier);
  let result;
  if (filtratedValues.length > 0) {
    result = minBy(filtratedValues, ({ value: val }) => val);
  } else {
    const filtratedValuesLower = allConvertedValues.filter(({ value: val, unit }) => val < 1 && unit.useInPrettier);
    result = maxBy(filtratedValuesLower, ({ value: val }) => val);
  }
  result.value *= sign;
  return result;
};
export const roundValue = (value) => {
  if (value < 10) {
    return Math.ceil(value);
  }
  return Math.ceil(value / 5) * 5;
};
export const convertValueToBaseUnit = (value, params) => _convertValueToBaseUnit(mappedUnitsFromJSON, value, params);
export const convertValueToUnit = (value, fromParams, toParams) => _convertValueToUnit(mappedUnitsFromJSON, value, fromParams, toParams);
export const getPrettifiedValue = (value, params) => _getPrettifiedValue(mappedUnitsFromJSON, value, params);
export const getBaseUnit = (fieldType) => _getBaseUnit(mappedUnitsFromJSON, fieldType);
